module.exports = __webpack_public_path__ + "img/extHigh.97dd08e2.webp";